import * as React from "react";
import { Label } from "../../../components/ui/label";
import { Input } from "../../../components/ui/input";
import { FieldError } from "./FieldError";

export function FormPhoneInput({
  register,
  setValue,
  label,
  id,
  stepName,
  stepId,
  extraInfo,
  disabled,
}) {
  const formatPhone = (value) => {
    // Remove all non-digits
    const digits = value.replace(/\D/g, "").slice(0, 10);

    // Format as (000) 000-0000
    if (digits.length < 4) return digits;
    if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  };

  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        type="tel"
        placeholder="(000) 000-0000"
        disabled={disabled}
        {...register(stepName, {
          onChange: (e) => {
            const v = formatPhone(e.target.value)
            e.target.value = v;
            setValue(stepName, v);
          },
        })}
      />
      <FieldError name={stepName} step={stepId} />
      {extraInfo && <p className="text-xs text-gray-500">{extraInfo}</p>}
    </div>
  );
}
